import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'

// Create HTTP link
const httpLink = createHttpLink({
  uri: '/functions/graphql',
})

// This will be set by the AuthProvider
let getToken = null

export const setGetToken = (fn) => {
  getToken = fn
}

// Create auth link to add token to requests
const authLink = setContext(async (_, { headers }) => {
  let token = ''
  if (getToken) {
    try {
      token = await getToken()
    } catch (error) {
      // Token fetch failed, continue without token
    }
  }

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  }
})

// Create Apollo Client
const client = new ApolloClient({
  link: from([authLink, httpLink]),
  cache: new InMemoryCache(),
})

export default client

